
const BarData = () => {

    var datos = []
    var categories = []


    for (let x = 0; x < 7; x++) {
        datos.push(
            {
                y: 100 * Math.random(),
                color: Math.random() < 0.5 ? "#ee3124" : "#1792e5"
            }
        )

        categories.push("Dato " + (x + 1))
        //console.log('***')
    }

    return { datos: datos, categories: categories }
}



export default BarData




